import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  Credentials,
  initialState,
  LoginStep
} from '@/modules/security/login/store/loginSlice/initialState.ts'

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setPreviousSessionOpen: (state, action: PayloadAction<boolean>) => {
      state.isPreviousSessionOpen = action.payload
    },
    setCurrentStep: (state, action: PayloadAction<LoginStep>) => {
      state.currentStep = action.payload
    },
    setCredentials: (state, action: PayloadAction<Credentials>) => {
      state.credentials = action.payload
    },
    reset: () => initialState
  }
})

export const loginActions = loginSlice.actions
export const { reducer: loginReducer } = loginSlice
